
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { GetStaticProps } from 'next';
import styled from 'styled-components';
import Page from 'shared/components/Page';
import Section from 'shared/components/Section';
import useTranslation from 'shared/hooks/useTranslation';
import PrivacyPolicyEn from 'modules/regulations/privacyPolicy/PrivacyPolicyEn';
import PrivacyPolicyPl from 'modules/regulations/privacyPolicy/PrivacyPolicyPl';
const StyledSection = styled(Section) `
  color: black;
  margin: 0 auto;
  max-width: 140rem;
  font-size: 1.6rem;
`;
function PrivacyPolicy(): JSX.Element {
    const { lang } = useTranslation('');
    return (<Page withLatestReviews={false}>
      <StyledSection>{lang === 'pl' ? <PrivacyPolicyPl /> : <PrivacyPolicyEn />}</StyledSection>
    </Page>);
}
const getStaticProps: GetStaticProps = async () => ({ props: {} });
export default PrivacyPolicy;

    async function __Next_Translate__getStaticProps__1968611f03d__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/privacy-policy',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1968611f03d__ as getStaticProps }
  